"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'wix-search-platform' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 99 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'wix-search-platform' });
    }
    ;
    /**
    * @typedef {Object} searchBoxSuggestionShowAllClickParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {string} documentType - pages|products|blog | all
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchBox.suggestShowAll.click. Evid: 244.
     * Event description: Should be sent after visitor submitted search in SearchBox by clicking 'Enter'.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * documentType - Type: string. Desc: pages|products|blog | all
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchBoxSuggestionShowAllClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchBoxSuggestionShowAllClick = function (params) {
        return this.bi.log(__assign({ evid: 244 }, params));
    };
    /**
    * @typedef {Object} searchBoxSearchSubmitParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {boolean} isDemo - True|False
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchBox.search.submit. Evid: 240.
     * Event description: Should be sent after visitor submitted search in SearchBox by clicking 'Enter'.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * isDemo - Type: bool. Desc: True|False
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchBoxSearchSubmitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchBoxSearchSubmit = function (params) {
        return this.bi.log(__assign({ evid: 240 }, params));
    };
    /**
    * @typedef {Object} searchBoxSuggestionsRequestStartedParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchBox.suggestLoad.started. Evid: 241.
     * Event description: Should be sent after visitor change query in SearchBox.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchBoxSuggestionsRequestStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchBoxSuggestionsRequestStarted = function (params) {
        return this.bi.log(__assign({ evid: 241 }, params));
    };
    /**
    * @typedef {Object} searchBoxSuggestionsRequestFinishedParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {string} error - error
    * @property {number} loadingDuration - time between load start and load.finish
    * @property {number} resultCount - result count
    * @property {string} resultsArray - {"all":17, "pages":5, "products":2, "blog":10}
    * @property {boolean} success - success
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchBox.suggestLoad.finished. Evid: 242.
     * Event description: Should be sent after visitor submitted search in SearchBox by clicking 'Enter'.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * error - Type: string. Desc: error
     *
     * loadingDuration - Type: numeric. Desc: time between load start and load.finish
     *
     * resultCount - Type: numeric. Desc: result count
     *
     * resultsArray - Type: string. Desc: {"all":17, "pages":5, "products":2, "blog":10}
     *
     * success - Type: bool. Desc: success
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchBoxSuggestionsRequestFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchBoxSuggestionsRequestFinished = function (params) {
        return this.bi.log(__assign({ evid: 242 }, params));
    };
    /**
    * @typedef {Object} searchBoxSuggestionClickParams
    * @property {string} correlationId - correlation_id
    * @property {string} documentType - pages|products|blog
    * @property {string} pageUrl - url
    * @property {string} resultsArray - {"all":17, "pages":5, "products":2, "blog":10}
    * @property {number} searchIndex - index of the clicked item from search result set (search_index starts from 0)
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchBox.suggestResults.click. Evid: 243.
     * Event description: Should be sent after visitor submitted search in SearchBox by clicking 'Enter'.
    
     * correlationId - Type: string. Desc: correlation_id
     *
     * documentType - Type: string. Desc: pages|products|blog
     *
     * pageUrl - Type: string. Desc: url
     *
     * resultsArray - Type: string. Desc: {"all":17, "pages":5, "products":2, "blog":10}
     *
     * searchIndex - Type: numeric. Desc: index of the clicked item from search result set (search_index starts from 0)
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchBoxSuggestionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchBoxSuggestionClick = function (params) {
        return this.bi.log(__assign({ evid: 243 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map